import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { SummitIdObject } from '@summit/models';

import { Editor } from 'primeng/editor';
import { SummitControl } from '../../models';
import { SFormErrorInputComponent } from '../s-form-error-input';

@Component({
  selector: 's-form-input-code',
  templateUrl: './s-form-input-code.component.html',
  styleUrls: ['./s-form-input-code.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, Editor, SFormErrorInputComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
//implements OnInit, AfterViewInit
export class SFormInputCodeComponent<T extends SummitIdObject> extends SummitControl<T> {
  @Input() toolbar: 'text' | 'simple' | 'normal' | 'full' = 'simple';
  //@Input() toolbar$: Observable<'text' | 'simple' | 'normal' | 'full'> = of('simple'); //couldn't get this to work with the editor toolbar
}
